/**
 * Redux actions for the info dialog.
 * @module redux/actions/info
 */

import { createAction } from "redux-actions";
import {
  getSavedState as apiGetSavedState,
  saveState as apiSaveState
} from "../api/savedState";
import States from "./";

export const LOAD = "SAVED_STATE/LOAD";
export const LOADED = "SAVED_STATE/LOADED";
export const LOAD_FAILED = "SAVED_STATE/LOAD_FAILED";
export const UPDATE = "SAVED_STATE/UPDATE";
export const RESTORE = "SAVED_STATE/RESTORE";

export const getSavedState = () => (dispatch, getState) => {
  dispatch(createAction(LOAD));
  const userId = getState().auth.user.userId;

  return apiGetSavedState(userId)
    .then(response => {
      return dispatch(createAction(LOADED)({ savedState: response.data }));
    })
    .catch(error => {
      console.error(error);
      return dispatch(createAction(LOAD_FAILED));
    });
};

export const saveState = () => (dispatch, getState) => {
  const savedState = {};
  Object.keys(States)
    .filter(k => k !== "savedState")
    .forEach(key => {
      if (States[key] && States[key].saveState) {
        savedState[key] = dispatch(States[key].saveState());
      }
    });

  apiSaveState(getState().auth.user.userId, savedState);
  return dispatch(createAction(UPDATE)({ savedState }));
};

export const restoreState = state => (dispatch, getState) => {
  const stateToRestore = state || getState().savedState.savedState;
  dispatch(createAction(RESTORE)());
  Object.keys(States)
    .filter(k => k !== "savedState")
    .forEach(key => {
      if (
        States[key] &&
        States[key].restoreState &&
        stateToRestore &&
        stateToRestore[key]
      ) {
        dispatch(States[key].restoreState(stateToRestore));
      }
    });
  return;
};

export const actions = {
  getSavedState,
  saveState,
  restoreState
};



// WEBPACK FOOTER //
// ./app/actions/savedState.js